<template>
  <div class="wenti_box">
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          实体营业执照和公章携带不方便，总是容易弄丢，如何获取电子营业执照和电子公章？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          新设立企业申领营业执照的同时，可在市统一电子印章管理平台（地址：https://amr.sz.gov.cn/elecseal/seal-web/#/home）免费申领一套四枚电子印章（法定名称章、财务专用章、合同专用章、法定代表人名章）。存量企业可在市统一电子印章管理平台（地址：https://amr.sz.gov.cn/elecseal/seal-web/#/home）免费申领一套四枚电子印章（法定名称章、财务专用章、合同专用章、负责人章）。商事主体负责人（企业法定代表人、个体户经营者）通过微信、支付宝中的电子营业执照小程序或电子营业执照APP等方式，通过实名核身后自行下载“电子营业执照”。
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">商事登记</div>
        <div class="time">2021-08-14 20:30:01</div>
      </div>
    </div>
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          哪里可以查询到商事主体有没有被载入经营异常名录、载入的原因？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          （1）登录深圳市市场监管局官网商事登记簿查询平台https://amr.sz.gov.cn/outer/entSelect/gs.html
          （2）录入单位名称、统一社会信用代码、验证码；
          （3）点击《深圳市市场监督管理局商事主体登记及备案信息查询单》【经营异常信息】即可获取。
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">商事登记</div>
        <div class="time">2021-09-13 16:50:48</div>
      </div>
    </div>
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          哪里可以下载本企业的章程？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          如需获取本企业章程，可登陆深圳市市场监督管理局官网首页【企业登记档案查询】获取，网址：https://amr.sz.gov.cn/ARCMIS.WebUI/Userlogin.aspx
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">商事登记</div>
        <div class="time">2021-08-14 20:30:20</div>
      </div>
    </div>
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          哪里可以领取电子印章？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          登录深i企官网首页（网址：https://www.szsiq.com/#/）--【办政务】--下拉“小助手”【电子印章】。
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">商事登记</div>
        <div class="time">2021-10-08 15:18:32</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.wenti_box {
  width: 1438px;
  background: #fff;
  .list-item {
    box-shadow: 0 1px 0 0 #eee;
    padding-bottom: 16px;
    margin: 16px 24px 17px 24px;
    box-sizing: border-box;
    padding: 12px 0 12px 0;
    .title {
      height: 33px;
      line-height: 33px;
      display: flex;
      .title-icon {
        width: 32px;
        height: 32px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACPTkDJAAADcklEQVRYCb1XzWsTQRR/bybtNjGxFltBsbYKolBbvCl4qSDkpNCbH2cvCv4HQqFnL1696EFQvIi3ioIXP1DQ4gcoVGxVtG0aKzYx2WZnnvM2TdxsJ+tuwQwk+z5/v7czuzP7EEKD3h/Lrbk0JAgHUEAaSMlQSDIVpSINFY1U6HZwHg8+Xg0CYEMhmhTwZnpEEQ03bP/jKhHnYDT/DnFSM75fAJN7M9NHUdD2/0EaxiSNxdTh/DMuQvhOc+edImc+n8tw+jKvuXLVOCudHtKRjwQ/cJ0mbvD5Dzs/7Q1Dp6/MLfxXrdPM63zMnUr8niOJcnF2olYrj5PSgwTgP8iIUEOUc06671a6d8+LWPdk9phUrEAOUp6zujJ71vPcI6TVrnAeEXQRqf2V8vJl45uKW0T9NQyjWfSfxQ8Xamu/J2zk4XC3snI6bGunx54B7blH/4KY/cssYMsw+y2AWRD+JzXsCzH+YhdgKLtB5iA9dhNS/ScMdPiIUOAtP4DK63NmuVq2+8gyQrcRESvkfPeei4Y8byHnPOn7OAal/BSB1OKKXYDjbLuNmb0tyTZFbNlHTs/2mzafzRa7gEzf0NPu3IEZG0jQ1pUbeZnu3f0qaIuSYxfAIKJnZyEKzI9x+n/8KyboT1QAabccTLbJcWKCeYkKENX52WCyTY4TE8xLVAAWrj0HqC4EAVrl6kI9ptUapSUqANyvVVm4cUWT8sKgbGMfx4R9UXqyAgwSLl3/UFz8/PFXqQxVd83/sexVih/ZF0Vm88XeCYEwJQUc0oSD4C3mfq1mfTwpBPRvy0IWV3IaxEmB9EVpeAtIG2Zp0wUgiDFz3F7SBDsYpE89gfLWEXC6UpDNOMBF6G/3+YQ8bwoEgbBEgFcJ9GsbadAmzL6pgoawLFHmDfmUOWZ8cvanS3dhQD+ErZmU+RhQQMW7AMt3mqkcyzmc2zTaBMONtZljxxFVfT5DQYhipzngrhqzE3LVVVxfwfaz7ZoP/0tE+rstn0iWBHcsNifbEPCMudjJOYCJ25NzhLOOwfKGwdyC26UNnqaBRpvipoX2GMwtuFfz2yU7QZ/dnMhqxWBO5q7vA6ZX43YpDGu+8xLvE3EwfC7DybE+Afdo3KtFzEQYd9M6czT6QgYxX1qtI9iem43nHhFZ35DWrPYaIpbMxnSqXXv+B3sISmgfMuYOAAAAAElFTkSuQmCC);
      }
      .questions {
        font-family: PingFangSC-Medium;
        margin-left: 16px;
        font-size: 20px;
        line-height: 33px;
        color: #333;
        letter-spacing: 0;
      }
    }
    .content {
      margin-top: 20px;
      line-height: 30px;
      display: flex;
      .answers-icon {
        width: 32px;
        height: 32px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACPTkDJAAADpElEQVRYCcVXTWgTQRT+ZtNUbRITa021SlH6B/5BqRYUFfyr9OBRRFAQLYiCBz0J4t2LoofSS714Ek9eROmhVEVBPYg/VZRaaZX+JzZNappkN+N702wqqdnsSlIfbHZ2dub73vvezNuMQI6NRuUWCXQIoA0StdT25gxx9Eg4MQgME04PtbvX+UT/nwDUN29SyvKxGG7S03kpoZn9xbwLgTThda314rIQIsnYyoEM+SMiPlBMwnxY5EgvOdHOTqhIOfKlImenmCujNgTnnPrelUp2CxU4HdvLeMHRYitJzvORc78KWKBDo0XQZjWwlO+YW+OtVkoSS2zi5hRY7nNt+idckWkYqyrhCk8htbEuixma0fH8cwyD4wmMR1Ko9rtRt3YZdjd5sdpXlh2Xr8HcYmSGsmFha65fI+IQpMcDbTaGqYtX8DYdxLOPUfQPxyFo9ZSVCQQDboSiOoy0BG0vbK1dgV2NXjStX26BTnMt39LL5KZ6VFDkgsgNnx96ZRVud49BuICa1eU43OxHS70H5eREypB4M/gLfR9m8H7ol7punLbOcEEHIsdOQSSTKB8aROjcJaXEQSJtrq9AQ818dBMRHS8pFTsaPGjNXJyWj9/jheJDwRQwgqGn4Y7HoHtXgrdNrr36Mou7vZM4vq8KezdbLqncqfb2/4Vb33Di9gTeDswuAlAdtIoMkl9S/tnuPQuj731UtQv92CpAaQNIpahw5Vmu9C0Bj+HXfL34FMU7WgN2zJYDHJ2KMK8DQJqiNxXQKWWS5tgxew5Q8GmWOIOYSEpcvTOM+30h1cMbmR00TfL4hUez+6/3gruAZzHgnwokdImBH3MIeOanmyl4/HoaLz/RdqXxK9y2YitcB0y3VbnK1CzeCKyIGaWpwGgoiYnpFNZQRWzfGTCnWt5tKWAiZFVlyUkFdsI0g8I+eaga+5tXqqJk9he629MpB4Vp05xnuthUzqntIjSuiE7snxzwVWhwE9HnoTjic7TiiVE5tCCIbR8cpcBEpW8NDrYE8PBFGGevf4Xf61IpefCUCtCbCH2gBDQK7ciOAPZs85nT/nq35UBbqx9h+tJtCC7Lgpw5GlQqPCHCkckENNJ/PJzAZITJBVwugVCjnh2fryFGZ2SUlHNWwPOhOewnIWMaHxoczivecOLWKPqe4iE6Q2Lu//63XMuc1bqc+V6U0V3MrarGfz+a8Rlt/qyGzswBsigh5oIwNl2d5rmQ3y+qm0t9PP8N5ESUFHS19TYAAAAASUVORK5CYII=);
      }
      .answers {
        width: 1100px;
        padding-left: 16px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #666;
        line-height: 30px;
        font-weight: 400;
      }
      .less {
        width: 1075px;
      }
      .zoom {
        align-self: flex-end;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #1072e0;
        text-align: right;
        cursor: pointer;
      }
    }
    .bottom {
      height: 30px;
      line-height: 30px;
      margin-top: 15px;
      display: flex;
      margin-left: 48px;
      align-items: center;
      .item-tag {
        min-width: 64px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        padding: 0 8px;
        background: #e8f0ff;
        border-radius: 12px;
        font-size: 12px;
        color: #1072e0;
      }
      .time {
        margin-left: 16px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #666;
        letter-spacing: 0;
      }
    }
  }
}
</style>
